// extracted by mini-css-extract-plugin
module.exports = {"headline":"lqgCFC","totals":"uzbgvO","line":"VichYS","divider":"sRIWuY","loading":"YJfNMn"};